export default __webpack_public_path__ + "1a6d0f64c701749e5c0709d58c1259ca.png";